export default "__VITE_ASSET__DUotZWoe__"